<template>
  <div class="gate d-flex align-items-center justify-content-center">
    <form class="gate-card" @submit.prevent="submit">
      <div class="gate-icon"><i class="pi pi-lock"></i></div>
      <h1 class="gate-title">قسم محمي</h1>
      <p class="gate-subtitle">هذا القسم (الاشتراكات والمدفوعات) محمي بكلمة مرور. برجاء إدخالها للمتابعة.</p>

      <div class="gate-field">
        <label class="gate-label">كلمة المرور</label>
        <Password
          v-model="password"
          placeholder="أدخل كلمة المرور"
          :feedback="false"
          toggleMask
          class="w-100"
          inputClass="w-full"
          :inputStyle="{ padding: '0.85rem', width: '100%' }"
          @keyup.enter="submit"
        />
        <span v-if="error" class="gate-error"><i class="pi pi-exclamation-circle"></i> {{ error }}</span>
      </div>

      <button type="submit" class="btn gate-btn" :disabled="store.submitting">
        <i class="pi" :class="store.submitting ? 'pi-spin pi-spinner' : 'pi-unlock'"></i>
        {{ store.submitting ? 'جارٍ التحقق...' : 'فتح القسم' }}
      </button>

      <router-link to="/" class="gate-back">رجوع للرئيسية</router-link>
    </form>
  </div>
</template>

<script>
import Password from 'primevue/password';
import { useSubsGateStore } from '@/stores/useSubsGateStore.js';

export default {
  name: 'SubscriptionsGate',
  components: { Password },
  data() {
    return { password: '', error: '' };
  },
  computed: {
    store() { return useSubsGateStore(); },
    redirect() { return this.$route.query.redirect || '/subscriptions'; },
  },
  methods: {
    async submit() {
      this.error = '';
      if (!this.password) { this.error = 'برجاء إدخال كلمة المرور'; return; }
      const res = await this.store.unlock(this.password);
      if (res.ok) {
        this.$router.replace(this.redirect);
      } else {
        this.error = res.message;
        this.password = '';
      }
    },
  },
  async mounted() {
    // If already unlocked (e.g. landed here by mistake), go straight through.
    if (this.store.unlocked === null) await this.store.checkStatus();
    if (this.store.unlocked === true) this.$router.replace(this.redirect);
  },
};
</script>

<style scoped>
.gate { min-height: 100vh; padding: 1.5rem; background: var(--surface-ground, #f4f7fb); }
.gate-card {
  width: 100%; max-width: 420px; background: var(--surface-card, #fff);
  border-radius: 24px; padding: 2.5rem 2rem; box-shadow: 0 18px 50px rgba(17,24,39,.1);
  text-align: center; display: flex; flex-direction: column; align-items: center;
}
.gate-icon {
  width: 66px; height: 66px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
  background: rgba(245,158,11,.14); color: #d97706; font-size: 1.7rem; margin-bottom: 1rem;
}
.gate-title { font-size: 1.5rem; font-weight: 800; color: var(--text-primary, #111827); margin: 0 0 .5rem; }
.gate-subtitle { color: var(--text-secondary, #6b7280); font-size: .9rem; line-height: 1.7; margin: 0 0 1.5rem; }
.gate-field { width: 100%; text-align: start; margin-bottom: 1.25rem; }
.gate-label { display: block; font-weight: 700; font-size: .9rem; margin-bottom: .5rem; color: var(--text-primary, #111827); }
.gate-error { display: inline-flex; align-items: center; gap: .3rem; color: #dc2626; font-size: .82rem; margin-top: .5rem; }
.gate-btn {
  width: 100%; background: #5B5FEF; color: #fff; border: 0; border-radius: 12px;
  padding: .85rem 1rem; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; gap: .5rem;
}
.gate-btn:disabled { opacity: .7; }
.gate-back { margin-top: 1rem; color: var(--text-secondary, #6b7280); font-size: .85rem; text-decoration: none; }
</style>
